"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.find");

var _DK = _interopRequireDefault(require("../DK"));

var _rules = _interopRequireDefault(require("./rules"));

var _toast = _interopRequireDefault(require("../utils/toast"));

var _type = _interopRequireDefault(require("../utils/type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isFunction = _type.default.isFunction;
/**
 * 表单校验
 * 参数：
 *  {
 *    selector：{String} 选择器
 *    fields:{Array} 检查项
 *      [{
 *        type:{func|reg|regName} 默认reg
 *        rule:{Function|String|Reg} 规则
 *        tip:{String} 提示语
 *        value:{Any} 最大值|最小值|最大长度|最小长度|等等
 *      }]
 *    closeTipsOnBlur：{Boolean} blur事件检查时是否提示，默认否
 *    onBlur：{Function} blur事件检查回调
 *      {
 *        result:{Boolean} 是否通过
 *        target:{DOM} 被检查的元素
 *      }
 *  }
 *  方法：
 *    validate：静态方法 校验数据是否满足
 *      {
 *        checkItem:检查内容
 *        type:{func|reg|regName} 默认regName
 *        rule:{Function|String|Reg} 规则
 *        value:{Any} 最大值|最小值|最大长度|最小长度|等等
 *      }
 *    validateAll：检查所有项是否满足
 *      {
 *        result:{Boolean} 是否通过
 *        target:{DOM} 不通过时被检查的元素
 *      }
 */

var Validator =
/*#__PURE__*/
function () {
  function Validator(opts) {
    _classCallCheck(this, Validator);

    var def = {
      selector: '',
      fields: [],
      closeTipsOnBlur: false,
      onBlur: null
    };
    this.opts = _objectSpread({}, def, opts);
    this.DK = (0, _DK.default)(this.opts.selector);
    this.inputs = this.DK.find('input');
    this.errorTip = null;

    this._event();
  }

  _createClass(Validator, [{
    key: "_event",
    value: function _event() {
      var _this = this;

      var _this$opts = this.opts,
          closeTipsOnBlur = _this$opts.closeTipsOnBlur,
          onBlur = _this$opts.onBlur;

      if (isFunction(onBlur)) {
        this.inputs.on('blur', function (e) {
          var target = e.target;

          var result = _this._validatorField(target);

          if (!result && !closeTipsOnBlur && _this.errorTip) {
            (0, _toast.default)(_this.errorTip);
          }

          onBlur({
            result: result,
            target: target
          });
        });
      }
    }
  }, {
    key: "_validatorField",
    value: function _validatorField(target) {
      var fields = this.opts.fields;
      var required = target.required,
          placeholder = target.placeholder,
          name = target.name,
          value = target.value;

      if (required && !value) {
        this.errorTip = placeholder;
        return false;
      }

      var field = fields[name];

      if (field && value) {
        for (var i = 0, length = field.length; i < length; i += 1) {
          var fieldRule = field[i];
          var result = Validator.validate(_objectSpread({}, fieldRule, {
            checkItem: value
          }));

          if (!result) {
            this.errorTip = fieldRule.tip;
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "validateAll",
    value: function validateAll() {
      var fields = this.inputs.el;

      for (var i = 0; i < fields.length; i += 1) {
        var target = fields[i];

        var result = this._validatorField(target);

        if (!result) {
          if (this.errorTip) {
            (0, _toast.default)(this.errorTip);
          }

          return {
            result: result,
            target: target
          };
        }
      }

      return {
        result: true
      };
    }
  }, {
    key: "getData",
    value: function getData() {
      var data = {};
      this.inputs.el.forEach(function (item) {
        var name = item.name,
            value = item.value;
        data[name] = value;
      });
      return data;
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this.inputs.el.forEach(function (item) {
        var name = item.name;

        if (data[name]) {
          item.value = data[name];
        }
      });
    }
  }], [{
    key: "validate",
    value: function validate(opts) {
      var _opts$type = opts.type,
          type = _opts$type === void 0 ? 'reg' : _opts$type,
          rule = opts.rule,
          value = opts.value,
          checkItem = opts.checkItem;
      var result = false;

      if (!rule) {
        return result;
      }

      if (type === 'reg') {
        result = rule.test(checkItem);
      } else if (type === 'func') {
        result = rule(checkItem, value);
      } else if (type === 'regName') {
        result = _rules.default[type][rule].test(checkItem);
      } else if (type === 'funcName') {
        result = _rules.default[type][rule](checkItem, value);
      }

      return result;
    }
  }]);

  return Validator;
}();

exports.default = Validator;